import React from "react";
import MetadataCache from "core/cache/Metadata";
import ViewerDashboard from "pages/viewer-dashboard";
import Autobind from "autobind-decorator";
import { inject, observer } from "mobx-react";
import "./theme-tide.css";
import "App.styl";
/**
 * React App main
 *
 * @class App
 * @extends {React.Component}
 */
@inject("metadataStore")
@inject("authStore")
@observer
@Autobind
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isUserLoaded: false,
      isCreditEnough: false,
    };
    this.handleMessage = this.handleMessage.bind(this);
  }
  componentDidMount() {
    const { metadataStore } = this.props;
    const metadataCache = new MetadataCache();
    metadataCache.setMetadataStore(metadataStore);
    window.addEventListener("message", this.handleMessage, false);

    // localStorage에 토큰이 없으면 기다림 (postMessage를 기다리도록 유지)
    const token = localStorage.getItem("token");
    if (token) {
      this.verifyToken(token);
    } else {
      // console.log("토큰이 없습니다. 부모 창으로부터 메시지를 기다립니다.");
    }
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleMessage, false);
  }

  handleMessage(event) {
    // const allowedOrigins = [
    //   "https://dev.iaidimage.co.kr",
    //   "https://webviewer-dev.iaidimage.co.kr"
    // ];
    const allowedOrigins = [
      `${process.env.REACT_APP_HOMEPAGE_URL}`,
      `${process.env.REACT_APP_WEBVIEWER_FOR_BACKEND_URL}`,
      `${process.env.REACT_APP_UPLOAD_URL}`,
    ];
    if (!allowedOrigins.includes(event.origin)) return;

    const { token } = event.data;
    if (token) {
      // ✅ 부모에게 받은 거 확인했다고 알림
      event.source.postMessage({ ack: true }, event.origin);
      localStorage.removeItem("token");
      // ✅ 토큰은 단 한 번만 처리하도록 조건
      if (!localStorage.getItem("token")) {
        localStorage.setItem("token", token);
        this.verifyToken(token);
      }
    }
  }

  verifyToken(token) {
    if (this.props.authStore) {
      this.props.authStore.setToken(token);
      // console.log(`${process.env.REACT_APP_HOMEPAGE_URL}/api/userinfo`);

      fetch(`${process.env.REACT_APP_HOMEPAGE_URL}/api/userinfo`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if (!res.ok) throw new Error("API 호출 실패");
          return res.json();
        })
        .then((userData) => {
          this.props.authStore.setUserID(userData.email);
          this.props.authStore.setCredit(userData.credit);
          this.setState({
            isLoading: false,
            isUserLoaded: true,
            isCreditEnough: userData.credit > 0, // 크레딧 확인
          });
        })
        .catch((error) => {
          console.error("사용자 정보 가져오기 실패:", error);
          this.setState({ isLoading: false, isUserLoaded: false });
        });
    }
  }

  render() {
    const { isLoading, isUserLoaded, isCreditEnough } = this.state;

    if (isLoading || !isUserLoaded) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            fontSize: "24px",
            fontWeight: "bold",
            color: "#e3e2e3",
          }}
        >
          LOADING...
        </div>
      );
    }

    if (!isCreditEnough) {
      return (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          크레딧이 부족합니다. 충전 후 다시 시도해주세요.
        </div>
      );
    }

    // 사용자 인증 및 크레딧 충족 시 ViewerDashboard 표시
    return (
      <React.Fragment>
        <ViewerDashboard />
      </React.Fragment>
    );
  }
}

export default App;
